// src/services/studies.js - Core study CRUD and patient data
// PACS infrastructure  → services/pacs.js
// DycoVue reporting    → services/reporting.js
// Statistics/analytics → services/analytics.js
import api from './api';

export const getStudies = async (filters = {}) => {
  try {
    const response = await api.get('/studies', { params: filters });
    return response.data;
  } catch (error) {
    console.error('Get studies error:', error);
    throw error;
  }
};

export const getStudyById = async (studyId) => {
  try {
    const response = await api.get(`/studies/${studyId}`);
    return response.data;
  } catch (error) {
    console.error('Get study error:', error);
    throw error;
  }
};

export const getStudyImages = async (studyId) => {
  try {
    const response = await api.get(`/studies/${studyId}/images`);
    return response.data;
  } catch (error) {
    console.error('Get study images error:', error);
    throw error;
  }
};

export const getStudyReports = async (studyId) => {
  try {
    const response = await api.get(`/studies/${studyId}/reports`);
    return response.data;
  } catch (error) {
    console.error('Get study reports error:', error);
    throw error;
  }
};

export const createStudy = async (studyData) => {
  try {
    const response = await api.post('/studies', studyData);
    return response.data;
  } catch (error) {
    console.error('Create study error:', error);
    throw error;
  }
};

export const updateStudy = async (studyId, studyData) => {
  try {
    const response = await api.patch(`/studies/${studyId}`, studyData);
    return response.data;
  } catch (error) {
    console.error('Update study error:', error);
    throw error;
  }
};

export const deleteStudy = async (studyId) => {
  try {
    const response = await api.delete(`/studies/${studyId}`);
    return response.data;
  } catch (error) {
    console.error('Delete study error:', error);
    throw error;
  }
};

export const getViewerUrl = async (studyId) => {
  try {
    const response = await api.get(`/studies/${studyId}/viewer-url`);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      console.warn(`No viewer URL found for study "${studyId}"`);
      return null;
    }
    console.error('Get viewer URL error:', error);
    throw error;
  }
};

export const getPatientHistory = async (patientId) => {
  try {
    const response = await api.get(`/studies/patient/${encodeURIComponent(patientId)}/history`);
    return response.data;
  } catch (error) {
    console.error('Get patient history error:', error);
    throw error;
  }
};

export const updatePatientMetadata = async (studyId, metadata) => {
  try {
    const response = await api.patch(`/studies/${studyId}/patient-metadata`, metadata);
    return response.data;
  } catch (error) {
    console.error('Update patient metadata error:', error);
    throw error;
  }
};
